import React from 'react';
import { Route, Routes, Navigate } from 'react-router-dom';
import UsersList from './UsersList';
import UserCreate from './UserCreate';
import UserEdit from './UserEdit';
import Profile from './Profile';

function Users() {
  return (
    <Routes>
      <Route path="/" element={<UsersList />} />
      <Route path="/create" element={<UserCreate />} />
      <Route path="/edit/:id" element={<UserEdit />} />
      <Route path="/profile" element={<Profile />} />
      <Route path="*" element={<Navigate to="/dashboard/users" replace />} />
    </Routes>
  );
}

export default Users;
